import { Dispatch } from "redux";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { ApiConfig } from "../../../../../config/ApiConfig";
import { AppStateWithData } from "../../../../AppStateWithData";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";
import { Collection } from "../../../../../models";
import { tempDTOForGanttGroup } from "./tempDtoForGantt";


export const getGroupForDocumentActionTypes = createRequestActionTypes('GET_GROUP_FOR_DOCUMENT')

export const getGroupForDocument = (config: ApiConfig) => (collectionUid: string) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<Collection, never> = {
        method: 'GET',
        requestActionTypes: getGroupForDocumentActionTypes,
        url: `${config.API_URL}/collections/info?collectionUid=${collectionUid}`,
        processResultBeforeDispatch: tempDTOForGanttGroup
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}